// extracted by mini-css-extract-plugin
export default {"filter":"FilterSection_filter__UCWWG"};